import { get, post } from "../../network/endpoint";
import { dispatchHandler, success } from "services/utils/action";
import * as ActionTypes from "services/state/action-types";

export function getQuotation(params, callback, callbackFail) {
  return (dispatch) => {
    const config = { params };
    const request = get("getQuotations", config);

    dispatch({
      type: ActionTypes.GET_QUOTATIONS_BY_PARAMS,
      payload: request,
    }).then(dispatchHandler(callback, callbackFail));
  };
}

export function getQuotationProducts(callback, callbackFail) {
  return (dispatch) => {
    const request = get("getQuotationProducts");

    dispatch({
      type: ActionTypes.GET_QUOTATION_PRODUCTS,
      payload: request,
    }).then(dispatchHandler(callback, callbackFail));
  };
}

export function setProduct(productId, productName) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.SET_QUOTATION_PRODUCT,
      selectedProduct: { id: productId, name: productName },
    });
  };
}

export function getConfigQuotationFields(productId, callback, callbackFail) {
  return (dispatch) => {
    const config = { pathValues: { productId } };
    const request = get("getConfigQuotationFields", config);

    dispatch({
      type: ActionTypes.GET_CONFIG_QUOTATION_FIELDS,
      payload: request,
    }).then(dispatchHandler(callback, callbackFail));
  };
}

export const createQuotation = (data, callback, callbackFail) => {
  return (dispatch) => {
    const config = {
      data: data,
    };
    const request = post("createQuotation", config);

    dispatch({
      type: ActionTypes.CREATE_QUOTATION,
      payload: request,
    }).then(dispatchHandler(callback, callbackFail));
  };
};

export function sendQuotationsByEmail(
  { protocolList, operationType, email },
  callback
) {
  return (dispatch) => {
    const config = { data: { protocolList, operationType, email } };
    const request = post("sendQuotationsByEmail", config);

    dispatch({
      type: ActionTypes.SEND_QUOTATIONS_BY_EMAIL,
      payload: request,
    }).then(success(callback));
  };
}

export function downloadQuotations({
  protocolList,
  operationType,
  messageResult,
}) {
  return (dispatch) => {
    const config = { data: { protocolList, operationType, messageResult } };
    const request = post("downloadQuotations", config);

    dispatch({
      type: ActionTypes.DOWNLOAD_QUOTATIONS,
      payload: request,
    }).then((result) => {
      window.location = result.payload.pathURL;
    });
  };
}



// WEBPACK FOOTER //
// ./src/services/state/quotation/action.js